/**
 * 縦のタイムライン(承認ルート・履歴)。
 *
 * なぜ新設か: antd `Steps` は横並び前提で、右パネル(幅 420)や FormPage の右カラム
 * (幅 340)では 1〜2 文字で折れる。`Timeline` は「状態」を持たない。承認ルートは
 * 「済 / いま / まだ / 却下」の 4 状態が主役なので、状態 → 色を 1 か所で持つ小さな
 * リストにした。
 */
import type { ReactNode } from "react";

export type StepState = "done" | "current" | "todo" | "rejected";

export type StepItem = {
  key: string;
  label: ReactNode;
  /** 日時・担当者など */
  sub?: ReactNode;
  state: StepState;
};

const MARK: Record<StepState, string> = { done: "✓", current: "●", todo: "", rejected: "✕" };

export function Steps({ items, ariaLabel = "手順" }: { items: StepItem[]; ariaLabel?: string }) {
  return (
    <ol className="ui-steps" aria-label={ariaLabel}>
      {items.map((it, i) => (
        <li key={it.key} className={`ui-step ui-step--${it.state}`}>
          <span className="ui-step-mark" aria-hidden>
            {MARK[it.state] || i + 1}
          </span>
          <div className="ui-step-text">
            <div className="ui-step-label">{it.label}</div>
            {it.sub && <div className="ui-step-sub">{it.sub}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}
